require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.object.entries");

require("core-js/modules/es6.array.find");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.set-prototype-of");

!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(exports) : "function" == typeof define && define.amd ? define(["exports"], e) : e((t = t || self)["@tinacms/core"] = {});
}(this, function (t) {
  "use strict";

  var _i = function i(t, e) {
    return (_i = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var i in e) {
        e.hasOwnProperty(i) && (t[i] = e[i]);
      }
    })(t, e);
  };

  var e = (n.prototype.subscribe = function (t) {
    var e = this;
    return this.__subscribers.push(t), function () {
      return e.unsubscribe(t);
    };
  }, n.prototype.unsubscribe = function (t) {
    var e = this.__subscribers.indexOf(t);

    this.__subscribers.splice(e, 1);
  }, n.prototype.notifiySubscribers = function () {
    this.__subscribers.forEach(function (t) {
      return t();
    });
  }, n);

  function n() {
    this.__subscribers = [];
  }

  var r = (o.prototype.getType = function (t) {
    return this.plugins[t] = this.plugins[t] || new c(t);
  }, o.prototype.findOrCreateMap = function (t) {
    return this.getType(t);
  }, o.prototype.add = function (t) {
    this.findOrCreateMap(t.__type).add(t);
  }, o.prototype.remove = function (t) {
    this.findOrCreateMap(t.__type).remove(t);
  }, o.prototype.all = function (t) {
    return this.findOrCreateMap(t).all();
  }, o);

  function o() {
    this.plugins = {};
  }

  var s,
      u,
      p,
      c = (_i(s = a, u = p = e), void (s.prototype = null === u ? Object.create(u) : (f.prototype = u.prototype, new f())), a.prototype.add = function (t) {
    var e = t;
    e.__type || (e.__type = this.__type), this.__plugins[e.name] = e, this.notifiySubscribers();
  }, a.prototype.all = function () {
    var e = this;
    return Object.keys(this.__plugins).map(function (t) {
      return e.__plugins[t];
    });
  }, a.prototype.find = function (t) {
    return this.__plugins[t];
  }, a.prototype.remove = function (t) {
    var e = "string" == typeof t ? t : t.name,
        i = this.__plugins[e];
    return delete this.__plugins[e], this.notifiySubscribers(), i;
  }, a);

  function f() {
    this.constructor = s;
  }

  function a(t) {
    var e = p.call(this) || this;
    return e.__type = t, e.__plugins = {}, e;
  }

  var _ = (y.prototype.registerApi = function (t, e) {
    this.api[t] = e;
  }, y);

  function y(t) {
    var n = this;
    void 0 === t && (t = null), this.api = {}, this.plugins = new r(), t && t.plugins && t.plugins.forEach(function (t) {
      return n.plugins.add(t);
    }), t && t.apis && Object.entries(t.apis).forEach(function (t) {
      var e = t[0],
          i = t[1];
      return n.registerApi(e, i);
    });
  }

  t.CMS = _, t.PluginType = c, t.PluginTypeManager = r, t.Subscribable = e, Object.defineProperty(t, "__esModule", {
    value: !0
  });
});